var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-youtube-iframe"},[(_vm.showVideo)?_c('iframe',{ref:"iframe",attrs:{"frameborder":"0","allowfullscreen":"","allow":"autoplay","src":_vm.videoYoutubeUrl,"loading":"lazy","title":_vm.title}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }